import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "device",
  "use": "device-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"device\"><g fill-rule=\"evenodd\"><path d=\"M0 7.951l8.01 4.624 7.959-4.624-2.051-1.186-5.874 3.415-5.959-3.438z\" /><path d=\"M0 11.175l8.01 4.623 7.959-4.623-2.051-1.187-5.874 3.415-5.959-3.438zM7.959 0L0 4.624 8.01 9.248l7.958-4.624z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id